import { render, staticRenderFns } from "./AddMeService.vue?vue&type=template&id=4914937f&"
import script from "./AddMeService.vue?vue&type=script&lang=ts&"
export * from "./AddMeService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports